<template>
    <div class="uk-container uk-align-center">
        <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ad948a7b1567d2f2f2f7f1a01b2258cb547067e2d3c176aaa9c65215b0ab3e56a&amp;source=constructor" width="100%" height="500" frameborder="0"></iframe>
        <!--iframe src="https://yandex.ru/maps/?um=constructor%3Ad948a7b1567d2f2f2f7f1a01b2258cb547067e2d3c176aaa9c65215b0ab3e56a&source=constructorLink" width="100%" height="500" frameborder="0"></iframe-->
    </div>    
</template>
